import { useTranslation } from 'react-i18next';

import './SearchInput.scss';

interface SearchInputProps {
  searchInput: string;
  setSearchInput: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = ({ searchInput, setSearchInput, placeholder, className }: SearchInputProps) => {
  const { t } = useTranslation('tag');

  return (
    <div className={`custom__search-wrapper ${className ?? ''}`}>
      <input
        id="search-input"
        type="text"
        className="custom__search-input"
        placeholder={placeholder ?? t('search.placeholder')}
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
      />

      <span className="custom__search-icon">
        <i className="fa fa-search" />
      </span>
    </div>
  );
};
